import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useJwt } from "react-jwt"
import { CreateEmployee, GetEmployeeRole, GetEmployeeStatus } from '../apiconfig/authService';

function AddCustomer() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [emailid, setEmailID] = useState('');
  const [empcode, setEmpcode] = useState('');
  const [employeephone, setEmployeePhone] = useState('');
  const [designation, setDesignation] = useState('');
  const [statusid, setStatusid] = useState(1);
  const [roleid, setRoleid] = useState(1);
  const [statusData, setStatusData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [categoryName, setCategoryName] = useState('');
  const [categoryId, setCategoryId] = useState('');

  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState('');


  const handleFirstNameChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleLastnameChange = (e) => {
    setLastname(e.target.value);
  };

  const handleEmployeeCodeChange = (e) => {
    setEmpcode(e.target.value);
  };

  const handleEmployeePhoneChange = (e) => {
    setEmployeePhone(e.target.value);
  };

  const handleDesignationChange = (e) => {
    setDesignation(e.target.value);
  };

  const handleEmailIdChange = (e) => {
    setEmailID(e.target.value);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(Number(e.target.value));
  };

  const handleRoleIdChange = (e) => {
    setRoleid(Number(e.target.value));
  };


  const validateInput = () => {
    if (firstname === "")
      throw new Error("Firstname is required");
    if (lastname === "")
      throw new Error("Lastname is required");
    if (emailid === '')
      throw new Error("Email ID is required.");
    if (!emailid.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/))
      throw new Error("Invalid email id provided.");
    if (password === '')
      throw new Error('Password is required.');
    if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/))
      throw new Error("Invalid password. It must contain at least one lowercase letter, one uppercase letter, one digit, one special character, and be at least 8 characters long.");
    if (password !== confirmPassword)
      throw new Error('Password and Confirm Password should be same.');
    if (employeephone === '')
      throw new Error('Phone number is required.');
    if (!employeephone.match(/^\d{10}$/))
      throw new Error("Invalid phone number.");
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    try {
      response = await CreateEmployee({ firstname, password, lastname, empcode, employeephone, designation, emailid, statusid, roleid }, localStorage.getItem('accessToken'))

      if (response.status === 201) {
        setIsMessageRed(false);
        setMessage(response.data.message);
        setCategoryName('');
        setCategoryId('');
        window.scrollTo(0, 0);
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
    }

  };

  useEffect(() => {
    (
      async () => {
        try {
          const statusResponse = await GetEmployeeStatus(localStorage.getItem('accessToken'));
          const rolesResponse = await GetEmployeeRole(localStorage.getItem('accessToken'));
          setStatusData(statusResponse.data.statuses);
          setRolesData(rolesResponse.data.roles);
        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Customer</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/employee" className="btn btn-primary">View All</NavLink>
          </div>
        </div>

        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}

        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="text" value={firstname} onChange={handleFirstNameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Firstname</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="text" value={lastname} onChange={handleLastnameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Lastname</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="text" value={emailid} onChange={handleEmailIdChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Email ID</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="text" value={employeephone} onChange={handleEmployeePhoneChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Phone Number</label>
              </div>

            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" id="floatingPassword" placeholder="Password" />
                <label htmlFor="floatingInput">Password</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="form-control" id="floatingPassword" placeholder="Password" />
                <label htmlFor="floatingInput">Confirm Password</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="text" value={empcode} onChange={handleEmployeeCodeChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Employee Code</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <input type="text" value={designation} onChange={handleDesignationChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Designation</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <select className="form-select" onChange={handleStatusIdChange} value={statusid} >
                  {
                    statusData?.map((item) => (
                      <option value={item.statusid}>
                        {item.status}
                      </option>
                    ))
                  }
                </select>
                <label htmlFor="floatingInput">Status</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-2">
                <select className="form-select" onChange={handleRoleIdChange} value={roleid} >
                  {
                    rolesData?.map((item) => (
                      <option value={item.roleid}>
                        {item.role}
                      </option>
                    ))
                  }
                </select>
                <label htmlFor="floatingInput">Role</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button type="submit" onClick={handleSubmitClick} className="btn btn-primary save-btn text-uppercase px-4">Add</button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddCustomer;
